module.exports = __webpack_public_path__ + "img/cashout_image.ad348d22.png";